var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFd2Img34(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.0833C0 6.30532 6.30532 0 14.0833 0C21.8613 0 28.1667 6.30532 28.1667 14.0833C28.1667 21.8613 21.8613 28.1667 14.0833 28.1667C6.30532 28.1667 0 21.8613 0 14.0833Z",
    fill: "#C49A6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2494 7.00003V9.68611L11.6406 11.4239V16.886L11.896 17.092L13.4372 12.0188L15.2241 17.474L17.0263 15.2176L17.862 17.5987V11.4239L19.253 9.68608V7H17.7076V8.26705H16.767V7.00003H15.2047V8.26705H14.2808V7.00003H12.7186V8.26705H11.7947V7.00003H10.2494ZM13.4531 13.9621L12.195 18.1036L9.843 16.2075L10.8106 19.0547L8 19.1834L9.28475 20.478L8.01564 22H10.9004L11.4762 21.4529L10.9388 19.9484L12.7272 20.6042L13.6331 17.9317L14.6671 20.8972L16.4715 19.5265L16.5364 21.6135L18.5571 21.3865L18.1239 22H21L18.9564 20.417L20.4008 18.3713L17.7585 19.0563L16.8311 16.4141L15.0053 18.7004L13.4531 13.9621Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFd2Img34);
export default __webpack_public_path__ + "static/media/FD2img34.9ef421c846015e2316d67eccdb4aad86.svg";
export { ForwardRef as ReactComponent };